import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlays = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 11 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.5 5.634a1 1 0 0 1 0 1.732l-8.25 4.763a1 1 0 0 1-1.5-.866V1.737A1 1 0 0 1 2.25.87l8.25 4.763Z" })
});
export default SvgPlays;
